import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, Routes} from '@angular/router';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {FuseModule} from '@fuse/fuse.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '@fuse/components';

import {fuseConfig} from 'app/fuse-config';

import {AppComponent} from 'app/app.component';
import {LayoutModule} from 'app/layout/layout.module';
import {SampleModule} from 'app/main/sample/sample.module';
import {LoginModule} from 'app/pages/login/login.module';

import {HttpRequestInterceptor} from 'app/services/http.interceptors';
import {ReportsModule} from './components/reports/reports.module';
import {AdminPageModule} from './pages/administration/administration.module';
import {SystemService} from './services/system.service';
import {ProjectTreeModule} from './components/project-tree/project-tree.module';
import {ErrorsHandler} from './util/errors/ErrorsHandler';
import {EntityInfoModule} from './components/entity-info/entity-info.module';
import {BillComponent} from './components/bill/bill.component';
import {CdkScrollableModule} from '@angular/cdk/scrolling';
import {AttributesModule} from './components/attributes/attributes.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {CalendarModule} from 'angular-calendar';
import {AuthInterceptor} from './services/auth/auth.interceptor';
import {HttpLoaderFactory} from './pages/product/product.model';
import {MatTooltipModule} from '@angular/material/tooltip';


const appRoutes: Routes = [
    {
        path        : 'proyecto',
        loadChildren: () => import('./pages/product.module').then(m => m.ProductModule)
    },
    {
        path        : 'administration',
        loadChildren: () => import('./pages/administration/administration.module').then(m => m.AdminPageModule)
    },

    {
        path        : 'hours',
        loadChildren: () => import('./pages/hours/hours.module').then(m => m.HoursModule)
    },
    {
        path        : 'calibrations',
        loadChildren: () => import('./pages/calibrations/calibrations.module').then(m => m.CalibrationsModule)
    },
    {
        path        : 'quotes',
        loadChildren: () => import('./pages/quotes/quotes.module').then(m => m.QuotesModule)
    },
    {
        path      : '**',
        redirectTo: 'auth/login'
    }
];

@NgModule({
    declarations: [
        AppComponent,
        BillComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, {
            onSameUrlNavigation: 'reload'
        }),


        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        SampleModule,
        CalendarModule,
        LoginModule,
        ReportsModule,
        AdminPageModule,
        ProjectTreeModule,
        EntityInfoModule,
        CdkScrollableModule,
        AttributesModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule
    ],
    providers: [
        // Http Interceptor(s) - orden importa: AuthInterceptor debe ir primero
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
        SystemService,
        {provide: ErrorHandler, useClass: ErrorsHandler}
    ],

    bootstrap: [
        AppComponent
    ]
})
export class AppModule
{
}
